<div class="row mb-4">
  <div class="col">
    <input #files id="files" type="file" style="display: none" (change)="onFilesAdded($event.target.files)" multiple>
    <button class="btn btn-warning" type="button" mat-raised-button (click)="fakeBrowseClick()">Upload Files</button>
    <span class="ml-3 accepted-file-types">Accepted file types: pdf, png, jpeg, doc, docx</span>
  </div>
</div>
@for (fileItem of documents['controls']; track fileItem; let i = $index) {
  <div class="row mt-2">
    <div class="col">
      <div [formGroup]="fileItem">
        <mat-chip-list>
          <app-field label="File Description">
            <input class="form-control" type="text" formControlName="subject">
          </app-field>
          <mat-chip class="remove-chip" [selectable]="true" [removable]="true" (removed)="removeItem(i)" (click)="removeItem(i)">
            {{fileItem.controls.filename.value}}
            <i class="fa fa-times-circle remove-icon"></i>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div>
}